// Generated by Melange

import * as Melange__Types from "./Types.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Option from "melange/option.js";
import * as JsxRuntime from "react/jsx-runtime";

function s(prim) {
  return prim;
}

function CompHeader(Props) {
  let comp = Props.comp;
  let nominals = Props.nominals;
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
    children: [JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("p", {
                    children: comp.compName,
                    className: "title is-3"
                  }),
                  JsxRuntime.jsx("p", {
                    children: Melange__Types.compSlug(comp),
                    className: "title is-5"
                  }),
                  JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("span", {
                                children: "UTC offset",
                                className: "tag"
                              }),
                              JsxRuntime.jsx("span", {
                                children: String(comp.utcOffset.timeZoneMinutes),
                                className: "tag is-warning"
                              })
                            ],
                            className: "tags has-addons"
                          }),
                          className: "control"
                        }),
                        JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("span", {
                                children: "minimum distance",
                                className: "tag"
                              }),
                              JsxRuntime.jsx("span", {
                                children: nominals.free,
                                className: "tag is-black"
                              })
                            ],
                            className: "tags has-addons"
                          }),
                          className: "control"
                        }),
                        JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("span", {
                                children: "nominal distance",
                                className: "tag"
                              }),
                              JsxRuntime.jsx("span", {
                                children: nominals.distance,
                                className: "tag is-info"
                              })
                            ],
                            className: "tags has-addons"
                          }),
                          className: "control"
                        }),
                        JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("span", {
                                children: "nominal time",
                                className: "tag"
                              }),
                              JsxRuntime.jsx("span", {
                                children: nominals.time,
                                className: "tag is-success"
                              })
                            ],
                            className: "tags has-addons"
                          }),
                          className: "control"
                        }),
                        JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("span", {
                                children: "nominal goal",
                                className: "tag"
                              }),
                              JsxRuntime.jsx("span", {
                                children: Stdlib.string_of_float(nominals.goal),
                                className: "tag is-primary"
                              })
                            ],
                            className: "tags has-addons"
                          }),
                          className: "control"
                        }),
                        JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("span", {
                                children: "score-back time",
                                className: "tag"
                              }),
                              JsxRuntime.jsx("span", {
                                children: Stdlib__Option.value(comp.scoreBack, ""),
                                className: "tag is-danger"
                              })
                            ],
                            className: "tags has-addons"
                          }),
                          className: "control"
                        })
                      ],
                      className: "field is-grouped is-grouped-multiline"
                    }),
                    className: "example"
                  })
                ],
                className: "tile is-child box"
              }),
              className: "tile is-parent"
            }),
            className: "tile"
          }),
          className: "tile is-ancestor",
          wrap: ""
        }),
        className: "container"
      })]
  });
}

const make = CompHeader;

export {
  s,
  make,
}
/* react/jsx-runtime Not a pure module */
